import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOculus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOculus"><Path d="M16.9248 5.5H7.07535C4.57018 5.5 2.51257 7.32229 2.05225 9.69553C1.35273 13.302 3.10428 18.5 7.24599 18.5H16.7542C20.8959 18.5 22.6474 13.302 21.9479 9.69553C21.4876 7.32229 19.43 5.5 16.9248 5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 8.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M1 8.625L1.86 9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22.1396 9.5L22.9996 8.625" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconOculus;
